import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
	OnInit,
	signal,
} from '@angular/core';
import { StorageService } from '@context/frontend/storage';
import { Content } from '@context/shared/types/common';
import { getPreferredThumbnail } from '@context/shared/types/media';
import { TuiHint, TuiSizeL, TuiSizeS } from '@taiga-ui/core';
import { TuiAvatar } from '@taiga-ui/kit';

const IconMap: { [key in 'folder' | 'file']: string } = {
	file: '@tui.sprout',
	folder: '@tui.folder',
};

@Component({
	imports: [TuiAvatar, TuiHint],
	selector: 'ctx-content-thumbnail',
	templateUrl: 'content-thumbnail.component.html',
	styleUrl: 'content-thumbnail.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		'[attr.size]': 'size()',
	},
})
export class ContentThumbnailComponent implements OnInit {
	readonly content = input.required<Content>();

	readonly size = input<TuiSizeS | TuiSizeL>('l');

	readonly badgeIcon = input<string | null>(null);

	readonly badgeHint = input<string | null>(null);

	readonly storageService = inject(StorageService);

	readonly thumbnailUrl = signal<string | null>(null);

	readonly icon = computed(() => IconMap[this.content().type]);

	async ngOnInit() {
		const res = await this.fetchThumbnail();
		this.thumbnailUrl.set(res);
	}

	fetchThumbnail() {
		const content = this.content();
		if (!content.thumbnails?.length) return Promise.resolve(null);

		const thumbnail = getPreferredThumbnail(content.thumbnails, {
			resolution: 256,
		});

		if (!thumbnail) return Promise.resolve(null);

		const storagePath = this.storageService.getReference(
			thumbnail.storagePath,
		);
		return this.storageService.getDownloadUrl(storagePath);
	}
}
